import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-solicitud-desbloqueo',
  imports: [],
  templateUrl: './solicitud-desbloqueo.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './solicitud-desbloqueo.css',
})
export class SolicitudDesbloqueo {
  titulo = input.required<string>();
  mensaje = input.required<string>();
  botonTexto = input.required<string>();

  desbloquear = output<void>();
  onDesbloquear() {
    this.desbloquear.emit();
  }
}
